// ponytail: flat array of single-emoji symbols. ~110 entries. No grouping, no keywords.
// Add a grouping layer later if/when users need > 50 + scroll fatigue.
export const SYMBOLS = [
  // Visages
  '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃',
  '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😋', '😜', '🤪',
  '🤔', '🤨', '😐', '😑', '😶', '🙄', '😬', '😴', '😷', '🤒',
  '🤕', '🥳', '😎', '🤓', '🧐', '😕', '😟', '😢', '😭', '😡',
  '🤬', '😈', '💀', '💩', '👻', '👽', '🤖',
  // Personnes / gestes
  '👤', '👥', '👮', '🕵️', '👷', '💂', '👻', '💀', '🧑', '👨',
  '👩', '🥷', '👨‍💻', '👩‍💻', '🧑‍🎓', '🤝', '👍', '👎', '✊', '👊',
  '🤛', '🤜', '🤞', '✌️', '🤟', '🤘', '👌', '🤌', '🤏', '👈',
  '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐️', '🖖', '👋', '🤙',
  // Animaux
  '🐺', '🐗', '🐴', '🦄', '🐮', '🐷', '🐭', '🐹', '🐰', '🐻',
  '🐨', '🐼', '🐸', '🐵', '🦊', '🐱', '🐯', '🦁', '🐮', '🐍',
  '🦅', '🦉', '🦇', '🐺', '🐢', '🐍', '🦂', '🕷️', '🦠', '🐛',
  // Nature
  '🌲', '🌳', '🌴', '🌵', '🌾', '🌿', '🍀', '🍁', '🍂', '🍃',
  '🌺', '🌻', '🌹', '🌷', '🌸', '💐', '🌎', '🌍', '🌏', '☀️',
  '🌙', '⭐', '🌟', '⚡', '🔥', '💧', '🌊', '🌪️', '🌫️', '☄️',
  // Nourriture
  '🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍈',
  '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🍆', '🥑', '🥦',
  '🍞', '🥐', '🥨', '🧀', '🥚', '🍳', '🥞', '🥓', '🍔', '🍟',
  // Activités
  '⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🏉', '🎱', '🏓', '🏸',
  '🥊', '🏆', '🥇', '🥈', '🥉', '🎯', '🎮', '🎲', '🎰', '🧩',
  '🎨', '🎭', '🎪', '🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🎷',
  // Objets
  '💰', '💵', '💴', '💶', '💷', '💸', '💳', '💎', '⚖️', '🪓',
  '🔪', '🗡️', '⚔️', '🔫', '🛡️', '🚬', '⚰️', '⚱️', '🏺', '🔮',
  '🧿', '🪬', '🧸', '🪆', '🖼️', '🎁', '🎈', '🎉', '🎊', '🪅',
  // Symboles
  '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔',
  '❌', '⭕', '🛑', '⛔', '🚫', '❗', '❕', '❓', '❔', '‼️',
  '⁉️', '💯', '🔞', '☢️', '☣️', '⬆️', '⬇️', '⬅️', '➡️', '🔄',
  // Technologie & sécurité (skewed for EBIOS context)
  '🛡️', '🔒', '🔓', '🔑', '🗝️', '⚙️', '🔧', '🔩', '🛠️', '⚡',
  '💻', '🖥️', '⌨️', '🖱️', '🖲️', '💾', '💿', '📀', '📱', '📞',
  '☎️', '📡', '🛰️', '📶', '🛜', '🔋', '🔌', '💡', '🔦', '🕯️',
  '🧯', '🛟', '⚠️', '🚨', '🚥', '🚦', '🛂', '🛃', '🛂', '✅',
  '❎', '🌐', '🕸️', '🕷️', '🦠', '🧬', '🔬', '🔭', '📡', '🛰️'
];

// ponytail: dedupe at module load, then reverse so the security/tech-heavy end of the list
// (🛡️ 🔒 🔑 💻 etc.) appears first. User asked for the order to be inverted.
const seen = new Set();
export const SYMBOLS_UNIQUE = SYMBOLS.filter(s => {
  if (seen.has(s)) return false;
  seen.add(s);
  return true;
}).reverse();
